import { useCallback, useState } from 'react';

import { Box, TextField } from '@mui/material';

import { SearchActionButtons } from '../SearchActionButtons';

interface SearchFieldProps {
    onCancel: () => void;
    onApply: (value: string) => void;
    handleClose?: () => void;
    name: string;
    label: string;
    placeholder?: string;
    defaultValue?: string;
    id?: string;
}

const SearchField = ({ defaultValue, label, name, placeholder, onCancel, onApply, handleClose, id = name }: SearchFieldProps) => {
    const [value, setValue] = useState(defaultValue ?? '');

    const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value);
    }, []);

    const handleClear = useCallback(() => {
        setValue('');
    }, []);

    const handleCancel = useCallback(() => {
        handleClear();
        onCancel();
        if (handleClose) {
            handleClose();
        }
    }, [onCancel, handleClear, handleClose]);

    const handleApply = useCallback(() => {
        onApply(value);
        if (handleClose) {
            handleClose();
        }
    }, [value, onApply, handleClose]);

    return (
        <Box>
            <Box p={2}>
                <TextField
                    /* eslint-disable-next-line jsx-a11y/no-autofocus */
                    autoFocus
                    data-testid={`${name}_search`}
                    data-locator={`${name}_search`}
                    fullWidth
                    name={name}
                    label={label}
                    placeholder={placeholder}
                    value={value}
                    onChange={handleChange}
                    defaultValue={defaultValue}
                    id={id}
                />
            </Box>
            <SearchActionButtons onApply={handleApply} onCancel={handleCancel} />
        </Box>
    );
};

export { SearchField };
